// Meta Pixel utility
const PIXEL_ID = '1522020766073660';

export function initPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

export function pixelViewContent(product) {
  if (!window.fbq) return;
  window.fbq('track', 'ViewContent', {
    content_name: product.name,
    content_category: product.category,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price,
    currency: 'INR',
  });
}

export function pixelAddToCart(product, qty) {
  if (!window.fbq) return;
  window.fbq('track', 'AddToCart', {
    content_name: product.name,
    content_ids: [product.id],
    content_type: 'product',
    value: product.price * qty,
    currency: 'INR',
  });
}

export function pixelInitiateCheckout(cartTotal, cartCount) {
  if (!window.fbq) return;
  window.fbq('track', 'InitiateCheckout', {
    value: cartTotal,
    currency: 'INR',
    num_items: cartCount,
  });
}

export function pixelPurchase(orderId, total, products) {
  if (!window.fbq) return;
  // CHANGED: added eventID as the 3rd argument to fbq('track', ...) —
  // this is Meta's dedup key, matched against the server-side event_id
  // sent from send-conversion-event.js using the same orderId. Without
  // this, Meta would count this purchase twice (once from browser,
  // once from server).
  window.fbq('track', 'Purchase', {
    content_ids: products.map(p => p.id),
    content_type: 'product',
    value: total,
    currency: 'INR',
    order_id: orderId,
  }, { eventID: orderId });
}